import axios from "axios";
import * as amplitude from "@amplitude/analytics-browser";
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import { globalCountryDetailsDictionary } from "../../../core/global/global-country-details";
import { trademoTrackingEvents } from "../../../core/global/trademo-tracking";
import { generateTrackingObject, getInitials } from "../../../core/global/global-country-functions";
import LocalStorageService from "../../../core/services/local-storage.service";
import MultiSelect from "../../../shared/MultiSelect";
import { getAccountsUrl } from "../../../utils/accountsUrl";
import { getApiUrl } from "../../../utils/baseUrl";
import { globalBaseUrl } from "../../../utils/globalBaseUrl";
import { getIntelUrl } from "../../../utils/intelUrl";
import { getPaymentsUrl } from "../../../utils/paymentsUrl";
import "./intel-header.scss";
import NotificationModal from "./notification-modal";
import * as Sentry from "@sentry/browser";
import { umsRedirection } from "./header-product-linking-dropdown-list";
import { CLOUDINARY_INTEL_BASE_URL, getSidebarLabel } from "../../../utils/enum";
import { useSelector } from "react-redux";
import PrimarySearchCard from "@shared/country-components/search-container/primarySearchCard";
import { Search } from "react-feather";
import ProductLinkingDropdown from "./header-product-linking-dropdown";
import ReportIssueModal from "../../../containers/ResourceCenter/ReportIssueModal";
import SuggestFeaturesModal from "../../../containers/ResourceCenter/SuggestFeaturesModal";
import OnBoardingDropdown from "@routes/intel/onboarding-screens/onboarding/OnBoardingDropdown";
import { refreshOnboardingData, toShowOnboarding } from "@routes/intel/onboarding-screens/onboarding/utils";

const intelHeader = {
  logoutUser: `${globalBaseUrl()}/auth/logout`,
  profile: getApiUrl("getUserProfile"), // Deprecated - use profileComplete and profileIntel instead
  profileComplete: globalBaseUrl("auth/getUserProfileComplete"),
  profileIntel: getApiUrl("getUserIntelDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  featureNudgeUpdate: getApiUrl("featureNudgeUpdate"),
  notification_center: getApiUrl("notification_center/get_notifications"),
};
const localStorageService = LocalStorageService.getService();
export default function IntelHeaderUsImport(props) {
  const { userData, creditDetails } = useSelector((state) => state.userDetails);
  const history = useHistory();
  const url = history.location.pathname + history.location.search;
  const showClassifier = url.includes("hs-classifier");
  const isResourceCenter = url.includes("help-center");
  const pageLabel = isResourceCenter ? "" : (props?.pageLabel ?? getSidebarLabel(history.location.pathname));
  const [fullName, setfullName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [userplan, setPlanDetails] = useState("");
  const [initials, setInitials] = useState("");
  const [currentProduct, setCurrentProduct] = useState("");
  const [parentProductArr, setParentProductArr] = useState([]);
  const [hsCodeList, setHsCodeList] = useState([]);
  const [showNotification, setNotification] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [saveSearchNotification, setSaveSearchNotification] = useState([]);
  const [count, setCount] = useState(0);
  const [headerProductDropDown, setHeaderProductDropDown] = useState(false);
  const [showReportIssueModal, setShowReportIssueModal] = useState(false);
  const [showSuggestFeaturesModal, setShowSuggestFeaturesModal] = useState(false);
  const [showHelpImproveSub, setShowHelpImproveSub] = useState(false);
  const [profileDropDown, setProfileDropDown] = useState(false);
  const [helpSectionDropDown, setHelpSectionDropDown] = useState(false);
  const [redirectCountry, setRedirectCountry] = useState("multi");
  const [redirectDirection, setRedirectDirection] = useState("country");
  const companyDetails = useSelector((state) => state?.[props?.type]);
  const searchCardDetails = useSelector((state) => state?.shipmentDetails?.searchParameters);
  const GLOBALPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("global"))?.navigate === "search";
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const [onboardingDropdown, setOnboardingDropdown] = useState(false);
  const iconRef = useRef();
  const searchCardRef = useRef(null);
  const allAppsRef = useRef(null);
  const profileRef = useRef(null);
  const helpSectionRef = useRef(null);
  //for onboarding
  const [obCompletion, setOBCompletion] = useState(0);
  const [itemClicked, setItemClicked] = useState(false);
  const showOnboardingButton = !isResourceCenter && obCompletion < 100 && obCompletion >= 0;
  const showSearch = !(isResourceCenter || showClassifier || url.includes("company-search") || url.includes("product-search") || props?.type === "hermes");

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchCardRef.current && !searchCardRef.current.contains(event.target)) {
        if (props.setShowGlobalPrimarySearchCard) {
          props.setShowGlobalPrimarySearchCard(false);
        }
      }
      if (allAppsRef.current && !allAppsRef.current.contains(event.target)) {
        setHeaderProductDropDown(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileDropDown(false);
      }
      if (iconRef.current && !iconRef.current.contains(event.target)) {
        setNotification(false);
        if (props?.setNotification) props?.setNotification(false);
      }
      if (helpSectionRef.current && !helpSectionRef.current.contains(event.target)) {
        setHelpSectionDropDown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchCardRef, allAppsRef, profileRef, iconRef, helpSectionRef]);

  useEffect(() => {
    if (Object.keys(userData).length) {
      let data = userData;
      setfullName(data.fullName);
      setEmailId(data.email);
      setInitials(getInitials(data.fullName));
      setParentProductArr(data.parent_product_mapping);
      setIsAdmin(data.isInternalAdmin || data.isInternalUser || data.isAdmin);
    }
  }, [userData]);

  useEffect(() => {
    if (Object.keys(creditDetails)) {
      mappingUserPlanDetails(creditDetails);
    }
  }, [creditDetails]);

  useEffect(() => {
    if (url && url.includes("all-country-shipments")) {
      props.callNudgeHandler("multi_country_nudge", true);
    }
    getDataHandler();
    let userData = localStorageService.getUserData();
    for (const prop in globalCountryDetailsDictionary) {
      if (history.location.pathname.includes(globalCountryDetailsDictionary[prop].countryPathName) === true || url.toLowerCase().includes(globalCountryDetailsDictionary[prop].countryUrlDashboard) === true) {
        userData.current_product = globalCountryDetailsDictionary[prop].localProduct;

        if (props.setCurrentProduct) {
          props.setCurrentProduct(globalCountryDetailsDictionary[prop].localProduct);
        }
        setTimeout(() => {
          setCurrentProduct(globalCountryDetailsDictionary[prop].localProduct);
        }, 100);
        localStorageService.setDataToLocalStorage("userData", userData);
      }
    }
    if (!currentProduct && currentProduct === "") {
      setCurrentProduct(globalCountryDetailsDictionary.us_import.localProduct);
    }
  }, []);

  useEffect(() => {
    const calculatePercentage = () => {
      try {
        const onboardingData = JSON.parse(localStorage.getItem("onboarding"));
        if (!onboardingData) {
          return 0;
        }
        let onboardingStats = onboardingData.onboarding_details;

        const totalVideos = Object.keys(onboardingStats).length;
        const viewedCount = Object.values(onboardingStats).filter((item) => item && typeof item === "object" && item.isViewed === true).length;
        const percentageComplete = Math.round((viewedCount / totalVideos) * 100);
        setOBCompletion(percentageComplete);
      } catch (error) {
        setOBCompletion(0);
      }
    };
    const initializeOnboardingData = async () => {
      const onboardingData = localStorage.getItem("onboarding");
      if (!onboardingData) {
        // If no data in localStorage, fetch from API
        await refreshOnboardingData();
      }
      calculatePercentage();
    };
    initializeOnboardingData();
    const handleStorageChange = (e) => {
      if (e.key === "onboarding") {
        calculatePercentage();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [itemClicked]);

  useEffect(() => {
    const searchUrlParams = window.location.search;
    const selectedCountryCode = searchCardDetails?.dataSource?.split("_")[0] ?? "multi_country";
    const isMultiCountry = selectedCountryCode?.toLowerCase() === "world" || selectedCountryCode?.toLowerCase() === "multi";
    if (props?.type && searchCardDetails?.dataSource !== "") {
      setRedirectCountry(selectedCountryCode?.toLowerCase() === "cl" ? "ch" : !isMultiCountry ? selectedCountryCode?.toLowerCase() : "multi");
      setRedirectDirection(!isMultiCountry ? new URLSearchParams(searchUrlParams).get("type") : "country");
    } else {
      setRedirectCountry("multi");
      setRedirectDirection("country");
    }
    if (GLOBALPLAN) {
      setRedirectCountry("global");
      setRedirectDirection("plan");
    }
  }, [companyDetails]);

  // Below is the code for the mapping the User Plan Details Data
  const mappingUserPlanDetails = (resData) => {
    if (!!resData && !!resData.featureAccess && resData.featureAccess[0] && resData.featureAccess[0].feature_name === "hsCodeLevel" && resData.featureAccess[0].feature_values && Array.isArray(resData.featureAccess[0].feature_values)) {
      let tempHsCodeArr = [];
      for (let i = 0; i < resData.featureAccess[0].feature_values.length; i++) {
        tempHsCodeArr.push({ ...resData.featureAccess[0].feature_values[i], isChecked: true });
      }
      setHsCodeList(tempHsCodeArr);
      let tempArr = tempHsCodeArr.filter((item) => item.isChecked === true).map((item) => item.key);
      if (props?.hsCodeApplyCalled) props?.hsCodeApplyCalled([...tempArr]);
    }
    if (!!resData && !!resData.data && resData.data.length > 0) {
      if (resData.data.length > 1) {
        for (const prop in globalCountryDetailsDictionary) {
          if (history.location.pathname.toLowerCase().includes(globalCountryDetailsDictionary[prop].countryPathName.toLowerCase()) === true || (globalCountryDetailsDictionary[prop].countryUrlDashboard.toLowerCase() !== "" && url.toLowerCase().includes(globalCountryDetailsDictionary[prop].countryUrlDashboard.toLowerCase())) || (!!globalCountryDetailsDictionary[prop].coProductsUrl && history.location.pathname.toLowerCase().includes(globalCountryDetailsDictionary[prop].coProductsUrl.toLowerCase()))) {
            for (let i = 0; i < resData.data.length; i++) {
              if (resData.data[i].user_active_plan.toLowerCase().includes(globalCountryDetailsDictionary[prop].compareProduct.toLowerCase()) === true) {
                setPlanDetails(resData.data[i].user_active_plan);
                break;
              }
            }
          }
        }
      } else {
        setPlanDetails(resData.data[0].user_active_plan);
      }
    } else {
      setPlanDetails("");
    }
  };
  async function executeSequentially() {
    const res = await toShowOnboarding();
    if (!res) {
      await props.handleNudgePopup("glossary", "event");
    }
  }

  const getDataHandler = () => {
    if (url.includes("free-trial")) {
      return;
    }
    axios
      .get(intelHeader.notification_center + `?source=all&is_notification=true`)
      .then(async ({ data: { data } }) => {
        if (props?.setShowDuePayment) {
          props?.setShowDuePayment(data?.due_payment_details ?? false);
        }
        if (!!data && !!data.data) {
          setDataList(data.data.filter((item) => item.source !== "sharedSaveSearch"));
          setSaveSearchNotification(data.data.filter((item) => item.source === "sharedSaveSearch"));
          setCount(data.count);
          localStorageService.setDataToLocalStorage("notification_Data", { data: data });
          if (data.count > 0 && !!props && !!props.handleNudgePopup) {
            await props.handleNudgePopup("notification_center", "event");
          }
        }
        if (props && props.handleNudgePopup) executeSequentially();
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };

  const logoutButtonFunction = () => {
    axios
      .get(intelHeader.logoutUser)
      .then((res) => {
        if (res.data.status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
          amplitude.reset();
          localStorageService.clearCompleteStorage();
          window.location.href = getAccountsUrl() + "signout";
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };
  const callNavigation = (type, data, redirectionUrl) => {
    let url = "";
    if (type === "plans") {
      callingTrackingEvents(trackingEventDictionary.headerUserProfilePlanDetails);
      url = getPaymentsUrl() + "payment?T=" + localStorageService.getAccessToken() + "&I=" + localStorageService.getSessionID() + "&D=" + localStorageService.getSessionExpiryDate() + "&type=" + type + "&P=" + (!!data && data !== "" ? data : localStorageService.getUserProduct()) + "&OId=" + localStorageService.getOptionId() + "&N=" + localStorageService.getNavigate();
    } else if (type === "payment-method") {
      url = getPaymentsUrl() + "payment?T=" + localStorageService.getAccessToken() + "&I=" + localStorageService.getSessionID() + "&D=" + localStorageService.getSessionExpiryDate() + "&type=" + type + "&P=" + (!!data && data !== "" ? data : localStorageService.getUserProduct()) + "&OId=" + localStorageService.getOptionId() + "&N=" + localStorageService.getNavigate();
    } else if (type === "profile") {
      callingTrackingEvents(trackingEventDictionary.headerUserProfileProfileDetails);
      url = getAccountsUrl() + "accounts?T=" + localStorageService.getAccessToken() + "&I=" + localStorageService.getSessionID() + "&D=" + localStorageService.getSessionExpiryDate() + "&type=" + type + "&P=" + (!!data && data !== "" ? data : localStorageService.getUserProduct()) + "&OId=" + localStorageService.getOptionId() + "&N=" + localStorageService.getNavigate();
    } else {
      url = redirectionUrl ? redirectionUrl : window.location.href;
    }
    window.location.href = url;
  };
  // Below code is used for Open the Zoho Chatbot window
  // End of the above code
  // Below code is used for handling the tracking events
  const callingTrackingEvents = (eventName, path) => {
    trademoTrackingEvents(eventName, generateTrackingObject(currentProduct, history.location.pathname && !!history.location.pathname && history.location.pathname !== "" ? history.location.pathname : "", userplan));
    if (!!path && path !== "") {
      history.push(getIntelUrl() + path);
    }
  };
  // End of the above code

  const handleUmsRedirection = () => {
    const { redirectionKey, redirectionUrl, pendo_event } = umsRedirection();
    callNavigation(redirectionKey, "", redirectionUrl);
    if (pendo_event) {
      callingTrackingEvents(pendo_event);
    }
  };

  const handleReportModalClose = () => {
    setShowReportIssueModal(false);
  };

  const handleSuggestFeaturesModal = () => {
    setShowSuggestFeaturesModal(false);
  };

  return (
    <>
      <div
        className={`
        tw-fixed ${props?.showDuePayment ? "tw-top-16" : "tw-top-0"} tw-z-[999] tw-bg-white tw-flex tw-justify-between tw-px-4 tw-py-1.5
        tw-transition-all tw-duration-300 tw-ease-in-out
        ${props.sideBarOpen ? "tw-left-[230px] tw-w-[calc(100%-230px)]" : "tw-left-20 tw-w-[calc(100%-80px)]"}
        ${props?.showGlobalPrimarySearchCard && !STARTERPLAN ? "tw-min-h-[170px] tw-max-h-[200px] tw-shadow-2xl" : props?.showGlobalPrimarySearchCard && STARTERPLAN ? "tw-min-h-[180px] tw-max-h-[200px] tw-shadow-2xl" : "tw-h-12 tw-shadow-header"}

      `}
        ref={searchCardRef}>
        {isResourceCenter && <div className="tw-text-base tw-font-semibold tw-text-gray-900 tw-mt-1">Help Center</div>}
        {pageLabel && !props?.showGlobalPrimarySearchCard && <div className="tw-text-base tw-font-semibold tw-text-gray-900 tw-self-center">{pageLabel}</div>}
        {!(isResourceCenter || showClassifier) && props?.showGlobalPrimarySearchCard ? (
          <div className="tw-absolute tw-w-[90%] tw-left-[5%] tw-top-[20%] tw-transition-all tw-duration-300 tw-ease-in-out">{<PrimarySearchCard showGetInTouch={props.showGetInTouch} handleGetInTouchClose={() => props.handleGetInTouchClose()} searchCardOptions={globalCountryDetailsDictionary[`${redirectCountry}_${redirectDirection}`]?.defaultDropDown} redirectCountry={redirectCountry} redirectDirection={redirectDirection} type={props?.type} handleGetInTouchOpen={() => props.handleGetInTouchOpen()} />}</div>
        ) : (
          <>
            {!(isResourceCenter || showClassifier) && hsCodeList && Array.isArray(hsCodeList) && hsCodeList.length ? (
              <MultiSelect
                currentProduct={currentProduct}
                userPlan={userplan}
                pathname={window && window.location && history.location.pathname ? history.location.pathname : ""}
                options={hsCodeList}
                applyClicked={(e) => {
                  props?.hsCodeApplyCalled(e, "click");
                  let tempOptions = [...hsCodeList];
                  for (let i = 0; i < tempOptions.length; i++) {
                    if (e.includes(tempOptions[i].key)) {
                      tempOptions[i].isChecked = true;
                    } else tempOptions[i].isChecked = false;
                  }
                  setHsCodeList([...tempOptions]);
                }}
              />
            ) : (
              <></>
            )}

            {showSearch && !props.country && !(hsCodeList && Array.isArray(hsCodeList) && hsCodeList.length) && (
              <div>
                <div className="tw-px-0 tw-py-0" onClick={() => props.setShowGlobalPrimarySearchCard(!props.showGlobalPrimarySearchCard)}>
                  <div className="tw-flex tw-justify-between tw-gap-2 tw-py-1.5 tw-px-4 tw-rounded-[37px] tw-border tw-border-gray-200 tw-bg-white tw-shadow-searchBar tw-min-w-[250px]">
                    <div className="tw-flex tw-flex-col tw-justify-center tw-gap-1.5 tw-min-w-[20%]">
                      <span className="tw-text-xs tw-font-medium tw-text-gray-900">Type to search here</span>
                    </div>
                    <div className="tw-flex tw-items-center">
                      <div className="tw-flex tw-items-center tw-ml-2">
                        <button className="tw-bg-primary-purple-500 tw-rounded-[50%] tw-w-[24px] tw-h-[24px] tw-p-1 tw-flex tw-items-center tw-justify-center">
                          <Search size={12} stroke="white" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="tw-flex tw-justify-end tw-gap-2.5">
              {!isResourceCenter && (
                <div className="tw-cursor-pointer tw-flex tw-items-center" ref={iconRef}>
                  <div
                    onClick={() => {
                      callingTrackingEvents(trackingEventDictionary.headerNotificationCentreButtonClick);
                      setNotification(!showNotification);
                      getDataHandler();
                    }}
                    className="tw-relative">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#667085">
                        <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z" />
                      </svg>
                    </span>
                    {count ? <div className="tw-absolute -tw-right-1 -tw-top-1.5 tw-bg-warning-500 tw-rounded-full tw-w-[16px] tw-h-[16px] tw-text-[10px] tw-font-medium tw-flex tw-items-center tw-justify-center tw-text-white tw-tracking-tight">{count > 99 ? "99+" : count}</div> : null}
                  </div>
                  {showNotification ? <NotificationModal setNotification={(val) => setNotification(val)} showNotification={showNotification} data={dataList} saveSearchNotification={saveSearchNotification} getDataHandler={getDataHandler} callingTrackingEvents={callingTrackingEvents} showOnboardingButton={showOnboardingButton} /> : null}
                </div>
              )}
              {/* do not remove this - if you want to hide for onboarding done shouldShowOnboarding() && */}
              {showOnboardingButton && (
                <div
                  className="tw-relative tw-flex tw-items-center tw-py-2 tw-px-3 tw-bg-[#fffaec] tw-border tw-border-gray-300 tw-gap-1 tw-rounded-[48px] tw-cursor-pointer"
                  onClick={() => {
                    setOnboardingDropdown(!onboardingDropdown);
                    callingTrackingEvents(trackingEventDictionary.onboardingButtonClick);
                  }}>
                  <span className="tw-text-sm tw-font-medium">Onboarding</span>
                  <span className="tw-h-4 tw-flex tw-items-center tw-text-xs tw-font-medium tw-bg-[#fac01d] tw-border-none tw-rounded-lg tw-text-gray-900 tw-py-0 tw-px-1">
                    {obCompletion}
                    {" %"}
                  </span>
                  {onboardingDropdown && <OnBoardingDropdown onboardingDropdown={onboardingDropdown} setOnboardingDropdown={setOnboardingDropdown} setItemClicked={(val) => setItemClicked(val)} itemClicked={itemClicked} handleSetCurrOnboarding={(val, trigger) => props?.handleSetCurrOnboarding(val, trigger)} updatingOnboardingData={(data) => props?.updatingOnboardingData(data)} type={props?.type} />}
                </div>
              )}
              {
                <div
                  id="resource_center_header"
                  className="tw-cursor-pointer tw-flex tw-items-center tw-border tw-border-gray-300 tw-rounded-[48px] tw-py-1 tw-pr-3 tw-pl-2 tw-gap-1"
                  ref={helpSectionRef}
                  onClick={() => {
                    setHelpSectionDropDown(!helpSectionDropDown);
                    setShowHelpImproveSub(false);
                    callingTrackingEvents(trackingEventDictionary.resourceCenterButtonClick);
                  }}>
                  <span className="material-symbols-outlined !tw-text-xl tw-text-gray-800">help</span>
                  <span className="tw-text-sm tw-font-medium">Help</span>
                  {helpSectionDropDown && (
                    <div className="tw-bg-white tw-absolute tw-top-[50px] tw-right-[170px] tw-shadow-sideDrawer tw-rounded-lg tw-min-w-52 tw-border tw-border-gray-300">
                      {!showHelpImproveSub ? (
                        <>
                          <a
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterGlossary);
                              window.open("/help-center?target=glossary", "_blank");
                              setHelpSectionDropDown(false);
                            }}>
                            Glossary
                          </a>
                          <a
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterFAQs);
                              window.open("/help-center?target=faqs", "_blank");
                              setHelpSectionDropDown(false);
                            }}>
                            FAQs
                          </a>
                          <a
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterTrainingSessions);
                              window.open("/help-center?target=training-sessions", "_blank");
                              setHelpSectionDropDown(false);
                            }}>
                            Training Sessions
                          </a>
                          <a
                            href="mailto:support@trademo.com"
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-primary-purple-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterConnectWithSupport);
                              setHelpSectionDropDown(false);
                            }}>
                            support@trademo.com
                          </a>
                          <div className="tw-border-t tw-border-gray-200" />
                          <div
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterHelpUsImprove);
                              setShowHelpImproveSub(true);
                            }}>
                            Help Us Improve
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterHelpUsImprove);
                              setShowHelpImproveSub(false);
                            }}>
                            <span className="material-symbols-outlined tw-mr-2 !tw-text-lg">arrow_back</span>
                            Help Us Improve
                          </div>
                          <div className="tw-border-t tw-border-gray-200" />
                          <div
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterReportAnIssue);
                              setShowReportIssueModal(true);
                            }}>
                            Report an Issue
                          </div>
                          <div
                            className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-gray-900 hover:tw-text-gray-900 hover:tw-bg-gray-50"
                            onClick={(e) => {
                              e.stopPropagation();
                              callingTrackingEvents(trackingEventDictionary.resourceCenterSuggestFeature);
                              setShowSuggestFeaturesModal(true);
                            }}>
                            Suggest Feature
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              }
              <div className="tw-border tw-border-gray-500 tw-flex tw-items-center tw-py-1 tw-px-2.5 tw-gap-1 tw-rounded-[47px] tw-text-sm tw-font-medium tw-cursor-pointer" ref={allAppsRef} onClick={() => setHeaderProductDropDown(!headerProductDropDown)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1d2939">
                  <path d="M263.79-192Q234-192 213-213.21t-21-51Q192-294 213.21-315t51-21Q294-336 315-314.79t21 51Q336-234 314.79-213t-51 21Zm216 0Q450-192 429-213.21t-21-51Q408-294 429.21-315t51-21Q510-336 531-314.79t21 51Q552-234 530.79-213t-51 21Zm216 0Q666-192 645-213.21t-21-51Q624-294 645.21-315t51-21Q726-336 747-314.79t21 51Q768-234 746.79-213t-51 21Zm-432-216Q234-408 213-429.21t-21-51Q192-510 213.21-531t51-21Q294-552 315-530.79t21 51Q336-450 314.79-429t-51 21Zm216 0Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21Zm216 0Q666-408 645-429.21t-21-51Q624-510 645.21-531t51-21Q726-552 747-530.79t21 51Q768-450 746.79-429t-51 21Zm-432-216Q234-624 213-645.21t-21-51Q192-726 213.21-747t51-21Q294-768 315-746.79t21 51Q336-666 314.79-645t-51 21Zm216 0Q450-624 429-645.21t-21-51Q408-726 429.21-747t51-21Q510-768 531-746.79t21 51Q552-666 530.79-645t-51 21Zm216 0Q666-624 645-645.21t-21-51Q624-726 645.21-747t51-21Q726-768 747-746.79t21 51Q768-666 746.79-645t-51 21Z" />
                </svg>
                <span>All Apps</span>
                <ProductLinkingDropdown isAdmin={isAdmin} parentProductArr={parentProductArr} callNavigation={(key1, key2, key3) => callNavigation(key1, key2, key3)} email={emailId} isOpen={headerProductDropDown} setIsOpen={setHeaderProductDropDown} />{" "}
              </div>

              <div className="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-font-medium tw-text-xs tw-text-white tw-bg-user-pill-bg tw-rounded-full tw-cursor-pointer " ref={profileRef} onClick={() => setProfileDropDown(!profileDropDown)}>
                {initials || "NA"}
                {profileDropDown && (
                  <div className="tw-bg-white tw-absolute tw-right-2 tw-top-14 tw-shadow-2xl tw-rounded-lg tw-min-w-52">
                    <a className="tw-cursor-default pb-9 hover-bg-none tw-py-2 tw-px-4 tw-flex tw-items-center tw-text-gray-900 tw-font-normal">
                      <span className="text-truncate user-dropdown-name">
                        <div className="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-font-medium tw-text-xs tw-text-white tw-bg-user-pill-bg tw-rounded-full tw-cursor-pointer">{!!initials && initials !== "" ? initials : "NA"}</div>
                        <span className="user-dropdown-right">
                          <span className="tw-text-sm text-capitalize">{!!fullName && fullName !== "" ? fullName : "User"}</span>
                          <span className="tw-text-xs">{emailId?.toLowerCase() ?? null}</span>
                        </span>
                      </span>
                    </a>
                    <div className="tw-border-t tw-border-gray-200" />
                    <a className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-[#212529] hover:tw-text-[#212529] hover:tw-bg-primary-purple-50" onClick={() => callNavigation("profile")}>
                      Profile Details
                    </a>
                    <a className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-[#212529] hover:tw-text-[#212529] hover:tw-bg-primary-purple-50" onClick={() => callNavigation("plans")}>
                      Plan Details
                    </a>
                    <div className="tw-border-t tw-border-gray-200" />
                    <span
                      onClick={() => {
                        callingTrackingEvents(trackingEventDictionary.headerUserProfileSupport);
                      }}
                    />
                    {isAdmin ? (
                      <>
                        <a className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-[#212529] hover:tw-text-[#212529] hover:tw-bg-primary-purple-50" onClick={handleUmsRedirection}>
                          User Management System
                        </a>
                        <div className="tw-border-t tw-border-gray-200" />
                      </>
                    ) : null}
                    <a onClick={() => logoutButtonFunction()} className="tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-normal tw-flex tw-items-center tw-text-[#212529] hover:tw-text-[#212529] hover:tw-bg-primary-purple-50 hover:tw-rounded-b-md">
                      <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1707728252/intel/icons/xkb7yvj12tnggbc5ptve.svg`} alt="sign-out-icon" />
                      Sign Out
                    </a>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {showReportIssueModal && <ReportIssueModal show={showReportIssueModal} handleClose={handleReportModalClose} />}
      {showSuggestFeaturesModal && <SuggestFeaturesModal show={showSuggestFeaturesModal} handleClose={handleSuggestFeaturesModal} />}
    </>
  );
}
